var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateFace5On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "#FFD8E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    stroke: "#FF77B1",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8975 20.0003C22.001 20.0002 22.0769 20.099 22.049 20.1986C20.6302 25.2651 12.2672 25.2644 10.9474 20.2129",
    fill: "#FF3D8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9474 20.2129C12.2672 25.2644 20.6302 25.2651 22.049 20.1986C22.0769 20.099 22.001 20.0002 21.8975 20.0003L11.099 20.0172C10.9969 20.0174 10.9215 20.1141 10.9474 20.2129Z",
    stroke: "#FF3D8F",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2998 10.3984L19.2998 13.9984L24.0998 14.3984",
    stroke: "#FF3D8F",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7002 10.3984L13.7002 13.9984L8.9002 14.3984",
    stroke: "#FF3D8F",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateFace5On);
export default __webpack_public_path__ + "static/media/icon-rate-face-5-on.b1ee2257e3be4de25f6001e03fe271f1.svg";
export { ForwardRef as ReactComponent };